import React, { Component } from "react";
import ReactDom from "react-dom";
import "../styles/main.less";
import moment from "moment";
import Mensajes from "../common/scripts/mensajes";
import ModalGeneral from "../common/scripts/ModalGeneralComponent";
import { isCallService } from "../common/scripts/services";
// import { Collapse, Well } from 'react-bootstrap';
import Sintomas from "../components/sintomas";
import Contactos from "../components/contactos";
import ResultadosPruebas from "../components/resultadosPruebas";
import CertificadoAislamiento from "../components/certificadoAislamiento";
import Viajes from "../components/viajes";
import Vacuna from "../components/vacuna";
import isEmail from "validator/es/lib/isEmail";
import isAlpha from "validator/es/lib/isAlpha";
import isAlphanumeric from "validator/es/lib/isAlphanumeric";
import isInt from "validator/es/lib/isInt";
import contains from "validator/es/lib/contains";

// import ConsentimientoInformado from '../components/consentimientoInformado'
// import SimpleBar from 'simplebar';
// import 'simplebar/dist/simplebar.css';
// import Switch from "react-switch";
export default class Index extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formSeleccionado: null,
      logedUser: null,
      nombre: null,
      nombres: null,
      apellidos: null,
      documentos: [],
      documentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
        CSIdDocumentoText: null,
        CSSiglaText: null,
      },
      medicoDocumentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
        CSIdDocumentoText: null,
        CSSiglaText: null,
      },
      grupoFamiliar: [],
      fechaNacimiento: null,
      email: null,
      emailIsValid: null,
      numeroDocumento: null,
      numeroDocumentoMedico: null,
      celular: null,
      telefonoFijo: null,
      direccion: null,
      barrio: null,
      ciudad: null,
      ciudadesListFromDepartamento: [],
      localidad: null,
      departamento: null,
      departamentosList: [],
      proveedorMuestra: null,
      fechaSintomas: null,
      fechaMuestra: null,
      fechaViaje: null,
      fechaRelacionContacto: null,
      certificado: "Seleccione una opción",
      incapacidad: "Seleccione una opción",
      numeroDiasIncapacidad: null,
      motivo: "Seleccione una opción",
      opcionesMotivo: [], //["Se venció y aún es positivo", "Se venció y aún no tengo resultado", "No fue expedida"],
      opciones: ["Si", "No"],
      ips: "Seleccione una opción",
      ipsList: [],
      numeroMuestraGestion: null,
      ciudadDondeSeEncuentra: null,
      ciudadDestino: "Seleccione una opción",
      medioValidacion: null,
      form1Pregunta1: false,
      form1Pregunta2: false,
      form1Pregunta3: false,
      formVacunaPregunta1: false,
      formVacunaPregunta2: false,
      observaciones: [],
      observacion: "Seleccione una opción",
      disable: true,
      procesoExitoso: null,
      riesgoResult: [],
      riesgosFromPnp: [],
      showModal: false,
      showModalForm1: false,
      showForm: false,
      showFormAislamiento: false,
      modalTerminosyCondiciones: false,
      showPDFButton: null,
      collapse: false,
      aceptaTerminosCondiciones: false,
      aceptaRecibirInformacion: false,
      fechaGeneracionCertificado: null,
      ciudadesList: [],
      embarazo: false,
      semanasGestacion: null,
      observacionDireccion: null,
    };
    this.pnpService = new ServicioPnp();
    this.getDocumentos = this.getDocumentos.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.consultarRieso = this.consultarRieso.bind(this);
    this.handleModalMessage = this.handleModalMessage.bind(this);
    this.handleFirstFormModal = this.handleFirstFormModal.bind(this);
    this.handleGenericHtml = this.handleGenericHtml.bind(this);
    this.getFechaDescargaCertificado =
      this.getFechaDescargaCertificado.bind(this);
    this.handleGenericTitleHtml = this.handleGenericTitleHtml.bind(this);
    this.updateDocument = this.updateDocument.bind(this);
    this.updateSintomas = this.updateSintomas.bind(this);
    this.handleIps = this.handleIps.bind(this);
    this.handleMedicodocument = this.handleMedicodocument.bind(this);
    this.handleMotivo = this.handleMotivo.bind(this);
    this.handlePlan = this.handlePlan.bind(this);
    this.handleCiudadDestino = this.handleCiudadDestino.bind(this);
    this.handleConvivenciaBeneficiario =
      this.handleConvivenciaBeneficiario.bind(this);
    this.updateObservacion = this.updateObservacion.bind(this);
    this.getDepartamentos = this.getDepartamentos.bind(this);
    this.handleTerminosCondiciones = this.handleTerminosCondiciones.bind(this);
    this.handleDireccion = this.handleDireccion.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.helperValidator = this.helperValidator.bind(this);
    this.descargarCertificado = this.descargarCertificado.bind(this);
    this.consultarRiesgoAislamiento = this.consultarRiesgoAislamiento.bind(this);
  }

  componentWillMount() {
    this.getDocumentos();
    this.pnpService.getListByTitle(
      "riesgosCovid",
      (list) => {
        this.setState({ riesgosFromPnp: list });
      },
      "",
      "Title",
      "MensajeRiesgo",
      "Asintomatico"
    );
    this.pnpService.getListByTitle(
      "AdministracionTerminosCondiciones",
      (item) => {
        this.setState({
          politicaTratamientoDatos: item.filter(
            (item) => item.Funcionalidad === "TerminosCondicionesCovid"
          ),
        });
      },
      "",
      "TerminosCondiciones",
      "Title",
      "Funcionalidad"
    );
  }

  componentDidMount() {
    setTimeout(() => {
      const logedUserInfo = compTools.obtenerInformacionUsuario();
      let observaciones = i18next.t("forms.observacionesList").split(",");
      let opcionesMotivo = i18next.t("forms.motivo").split(",");
      let ipsList = i18next.t("forms.ipsList").split(",");
      let ciudadesList = i18next.t("forms.ciudadesList").split(",");
      this.setState({
        logedUser: logedUserInfo,
        observaciones,
        opcionesMotivo,
        ipsList,
        ciudadesList,
      });
      // const myElement = document.getElementById('simplebar-scrollbar-covid');
      // new SimpleBar(myElement, { autoHide: false });
    }, 50);
    this.getDepartamentos();
    sessionStorage.removeItem("direccionFormCovid");
  }

  getDocumentos() {
    this.pnpService.getList(
      "tiposDocumento",
      (list) => {
        this.setState({ documentos: list });
      },
      "",
      "CSIdDocumentoText",
      "CSDocumentoIdentidadText",
      "CSSiglaText"
    );
  }

  getDepartamentos(isCiudad, departamento) {
    let data = {
      Accion: "GET",
      Lista: isCiudad ? "Ciudad" : "Departamento",
      UrlSitio: window.location.origin + "/salud",
      Vista: ["Title"],
      Campos: {
        Query: [
          isCiudad
            ? { NombreInternoCampo: "DEPTO", Valor: departamento, Tipo: "Text" }
            : {},
        ],
      },
    };
    isCallService({
      // loadingElement: '',
      service: "UtilidadSharepointGet",
      params: data,
      changeState: isCiudad
        ? "ciudadesListFromDepartamento"
        : "departamentosList",
      executeCallback: (result) => {
        if (isCiudad) {
          let ciudadesList = [];
          result.Resultado.map((item, index) => {
            let newOption = {
              value: item.Valores[0].Valor,
              label: item.Valores[0].Valor,
            };
            ciudadesList.push(newOption);
          });
          this.setState({ ciudadesListFromDepartamento: ciudadesList });
        } else {
          let departamentosList = [];
          result.Resultado.map((item, index) => {
            let newOption = {
              value: item.Valores[0].Valor,
              label: item.Valores[0].Valor,
            };
            departamentosList.push(newOption);
          });
          this.setState({ departamentosList });
        }
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }
  helperValidator(
    callback,
    text,
    argsStateSucces,
    argsStateFail = argsStateSucces
  ) {
    if (callback(text.trim())) {
      this.setState({ ...argsStateSucces });
      return;
    }
    if (text.trim() === "" && text.trim().length === 0) {
      this.setState({ ...argsStateFail });
    }
  }
  handleInput(event, selectedOption, lugar) {
    let targetType =
      lugar === "Ciudad"
        ? "Ciudad"
        : lugar === "Departamento"
        ? "Departamento"
        : event.target.name;
    let regexNombre = /[^a-z A-Z]+/g;
    let regexNumber = /\D+/g;
    let regexAlfaNum = /[^a-z A-Z0-9]+/g;
    let idDoc = this.state.documentSelected.CSIdDocumentoText;
    switch (targetType) {
      case "Nombre": //validado
      this.setState({
        nombre: event.target.value,
      })
       // this.helperValidator(isAlpha, event.target.value, {
        //  nombre: event.target.value,
        //});
        break;
      case "NumeroDocumento":
        this.helperValidator(isAlphanumeric, event.target.value, {
          numeroDocumento: event.target.value,
        });
        break;
      case "NumeroDocumentoMedico":
        this.helperValidator(isAlphanumeric, event.target.value, {
          numeroDocumentoMedico: event.target.value,
        });
        break;
      case "Email":
        this.helperValidator(
          (text) =>
            isAlphanumeric(text) || isEmail(text) || contains(text, "@"),
          event.target.value,
          {
            email: event.target.value,
            emailIsValid: isEmail(event.target.value),
          }
        );
        break;
      case "Celular":
        this.helperValidator(isInt, event.target.value, {
          celular: event.target.value,
        });

        break;
      case "TelefonoFijo":
        this.helperValidator(isInt, event.target.value, {
          telefonoFijo: event.target.value,
        });
        break;
      case "Direccion":
        this.setState({ direccion: event.target.value });

        break;
      case "Barrio":
        this.setState({ barrio: event.target.value });
        break;
      case "Ciudad":
        let ciudad = selectedOption ? selectedOption.value : event.target.value;
        this.setState({ ciudad: ciudad });
        break;
      case "CiudadDestino":
        this.setState({ ciudadDestino: event.target.value });
        break;
      case "Localidad":
        this.setState({ localidad: event.target.value });
        break;
      case "Departamento":
        let departamento = selectedOption
          ? selectedOption.value
          : event.target.value;
        this.setState({ departamento: departamento });
        break;
      case "Fecha":
        this.setState({ fechaSintomas: event.target.value });
        break;
      case "FechaViaje":
        this.setState({ fechaViaje: event.target.value });
        break;
      case "FechaNacimiento":
        this.setState({ fechaNacimiento: event.target.value });
        break;
      case "ProveedorMuestra":
        this.setState({ proveedorMuestra: event.target.value });
        break;
      case "FechaMuestra":
        this.setState({ fechaMuestra: event.target.value });
        break;
      case "FechaRelacionContacto":
        this.setState({ fechaRelacionContacto: event.target.value });
        break;
      case "Certificado":
        this.setState({ certificado: event.target.value });
        break;
      case "Incapacidad":
        this.setState({ incapacidad: event.target.value });
        break;
      case "NumeroDiasIncapacidad":
        this.helperValidator(isInt, event.target.value, {
          numeroDiasIncapacidad: event.target.value,
        });
        break;
      case "Motivo":
        this.setState({ motivo: event.target.value });
        break;
      case "Vencio":
        this.setState({ vencio: event.target.value });
        break;
      case "Expedida":
        this.setState({ expedida: event.target.value });
        break;
      case "NumMuestra":
        this.setState({ numeroMuestraGestion: event.target.value });

        break;
      case "CiudadDondeSeEncuentra":
        this.setState({ ciudadDondeSeEncuentra: event.target.value });
        break;
      case "MedioValidacion":
        this.setState({ medioValidacion: event.target.value });
        break;
      case "SemanasGestacion":
        let semanas = event.target.value.replace(regexNumber, "");
        if (semanas.length > 0) {
          semanas = parseInt(semanas);
        }
        if (semanas >= 45) {
          semanas = 45;
        }
        this.setState({ semanasGestacion: semanas });
        break;
      default:
        break;
    }
  }

  consultarRieso(event) {
    event.preventDefault();
    let data = {
      TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
      NumeroDocumento: this.state.numeroDocumento,
      // Opcion: "34",
      // TiempoCache: 1440,
      // FiltrarGrupoFamiliar: false,
      TiempoCache: 120,
    };
    isCallService({
      // loadingElement: '',
      service: "ObtenerRiesgosUsuario",
      params: data,
      changeState: "riesgos",
      executeCallback: (result) => {
        if (this.state.formSeleccionado == 5) {
          if (result.Observaciones !== "No existe Afiliado") {
            this.setState({ nombre: result.Nombre });
          }
          return;
        } else if (result.Observaciones !== "No existe Afiliado") {
          this.setState({ showForm: true, nombre: result.Nombre, showFormAislamiento: true });
        } else {
          this.setState({ error: true, sinUsuario: true, showForm: false, showFormAislamiento: false });
        }

        let riesgoResult = result;
        let filteredResutByRiesgos = riesgoResult.Riesgos.filter(
          (item) => item !== ""
        );
        riesgoResult.Riesgos = filteredResutByRiesgos;

        let grupoFamiliar = result;
        let grupoFamiliarFiltered = grupoFamiliar.GrupoFamiliar.filter(
          (item) => item["Parentesco"] !== "TR"
        );
        grupoFamiliar.GrupoFamiliar = grupoFamiliarFiltered;
        grupoFamiliar.GrupoFamiliar.map((item) => {
          item.isChecked = false;
        });

        this.setState({ riesgoResult, codigoPlan: grupoFamiliar }, () => {
          this.handleModalMessage();
        });
        this.getFechaDescargaCertificado("TemasCovid19-Riesgos");
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
  }


  consultarRiesgoAislamiento(event) {

    event.preventDefault();
    let data = {
      TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
      NumeroDocumento: this.state.numeroDocumento,
      // Opcion: "34",
      // TiempoCache: 1440,
      // FiltrarGrupoFamiliar: false,
      TiempoCache: 120,
    };
    isCallService({
      // loadingElement: '',
      service: "ObtenerRiesgosUsuario",
      params: data,
      changeState: "riesgos",
      executeCallback: (result) => {
        if (this.state.formSeleccionado == 5) {
          if (result.Observaciones !== "No existe Afiliado") {
            this.setState({ nombre: result.Nombre });
          }
          return;
        } else if (result.Observaciones !== "No existe Afiliado") {
          this.setState({ showForm: true, nombre: result.Nombre, showFormAislamiento: true });
        } else {
          this.setState({ error: true, sinUsuario: true, showForm: false, showFormAislamiento: false });
        }

        let riesgoResult = result;
        let filteredResutByRiesgos = riesgoResult.Riesgos.filter(
          (item) => item !== ""
        );
        riesgoResult.Riesgos = filteredResutByRiesgos;

        let grupoFamiliar = result;
        let grupoFamiliarFiltered = grupoFamiliar.GrupoFamiliar.filter(
          (item) => item["Parentesco"] !== "TR"
        );
        grupoFamiliar.GrupoFamiliar = grupoFamiliarFiltered;
        grupoFamiliar.GrupoFamiliar.map((item) => {
          item.isChecked = false;
        });

        this.setState({ riesgoResult, codigoPlan: grupoFamiliar }, () => {
          this.handleModalMessage();
        });
        //this.getFechaDescargaCertificado("TemasCovid19-Riesgos");
        let data = {
          Accion: "ADD",
          Lista: 'TemasCovid19-Riesgos',
          UrlSitio: window.location.origin + "/salud/transacciones",
          Campos: {
            Valores: [
              { NombreInternoCampo: "NombreCompleto", Valor: result.Nombre },
              {
                NombreInternoCampo: "TipoDocumento",
                Valor: result.TipoDocumento,
              },
              {
                NombreInternoCampo: "NumeroDocumento",
                Valor: result.NumeroDocumento,
              },
              { NombreInternoCampo: "DescargoCertificado", Valor: true },
              {
                NombreInternoCampo: "FechaGeneracionCertificado",
                Valor: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          },
        };
        isCallService({
          // loadingElement: '',
          service: "UtilidadSharepoint",
          params: data,
          changeState: "idUsuario",
          executeCallback: (result) => {
            this.getFechaDescargaCertificado("TemasCovid19-Riesgos");
          },
          error: "error",
          condition: true,
          showLogs: false,
          mainObject: this,
        });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
    
  }


  handlePlan(data) {
    isCallService({
      // loadingElement: '',
      service: "ObtenerRiesgosUsuario",
      params: {
        TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
        NumeroDocumento: this.state.numeroDocumento,
        // Opcion: "34",
        // TiempoCache: 1440,
        TiempoCache: 120,
      },
      changeState: "codigoPlan",
      executeCallback: (result) => {
        this.handleSubmit(data, result);
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  limpiarForm() {
    let medicoDocumentSelected = { ...this.state.medicoDocumentSelected };
    medicoDocumentSelected.CSDocumentoIdentidadText = "elija un documento";
    medicoDocumentSelected.CSIdDocumentoText = null;
    medicoDocumentSelected.CSSiglaText = null;
    this.setState({
      disable: true,
      nombre: "",
      email: "",
      numeroDocumento: "",
      celular: "",
      telefonoFijo: "",
      direccion: "",
      ciudadDestino: "",
      fechaViaje: null,
      fechaRelacionContacto: null,
      barrio: "",
      ciudad: "",
      localidad: "",
      departamento: "",
      motivo: "",
      observacion: "Seleccione una opción",
      form1Pregunta1: false,
      form1Pregunta2: false,
      form1Pregunta3: false,
      formVacunaPregunta1: false,
      formVacunaPregunta2: false,
      numeroDocumentoMedico: null,
      ips: "Seleccione una opción",
      semanasGestacion: null,
      embarazo: false,
    });
    this.setState({ medicoDocumentSelected });
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }

  updateDescargarCertificadoColumn(id) {
    isCallService({
      // loadingElement: '',
      service: "UtilidadSharepoint",
      params: {
        Accion: "UPDATE",
        Lista: "TemasCovid19-Riesgos",
        UrlSitio: window.location.origin + "/salud/transacciones",
        ID: this.state.idUsuario, //id ? id : this.state.procesoExitoso[0].ID,
        Campos: {
          Valores: [
            { NombreInternoCampo: "DescargoCertificado", Valor: true },
            {
              NombreInternoCampo: "FechaGeneracionCertificado",
              Valor: moment().format("YYYY-MM-DD HH:mm:ss"),
            },
          ],
        },
      },
      changeState: "procesoExitoso",
      executeCallback: (result) => {
        //console.log(result);
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
  }

  handleFirstFormModal() {
    return { __html: this.state.mensajeRiesgo[0].MensajeRiesgo };
  }

  handleModalMessage() {
    let isCovidAr = null;
    let isCovidBr = null;
    let sinRiesgo = null;
    let state = this.state;
    state.riesgoResult.Riesgos.map((item) => {
      if (item === "COVID-AR") {
        isCovidAr = true;
      } else if (item === "COVID-BR") {
        isCovidBr = true;
      } else {
        sinRiesgo = true;
      }
    });
    //al menos un checkbox esta en true
    state.form1Pregunta1 || state.form1Pregunta2 || state.form1Pregunta3
      ? this.setStateMensajeRiesgo(isCovidAr, isCovidBr, sinRiesgo, false)
      : this.setStateMensajeRiesgo(isCovidAr, isCovidBr, sinRiesgo, true);
  }

  setStateMensajeRiesgo(isCovidAr, isCovidBr, sinRiesgo, asintomatico) {
    if (isCovidAr) {
      this.setState({
        mensajeRiesgoTitle: i18next.t("modales.covidArTitle"),
        showPDFButton: !asintomatico,
        mensajeRiesgo: this.state.riesgosFromPnp.filter(
          (item) =>
            item.Title == "COVID-AR" && item.Asintomatico == asintomatico
        ),
      });
      return;
    }
    if (isCovidBr) {
      this.setState({
        mensajeRiesgoTitle: i18next.t("modales.covidBrTitleSintomatico"),
        showPDFButton: !asintomatico,
        mensajeRiesgo: this.state.riesgosFromPnp.filter(
          (item) =>
            item.Title == "COVID-BR" && item.Asintomatico == asintomatico
        ),
      });
      return;
    }
    this.setState({
      mensajeRiesgoTitle: i18next.t("modales.covidBrTitleAsintomatico"),
      showPDFButton: !asintomatico,
      mensajeRiesgo: this.state.riesgosFromPnp.filter(
        (item) =>
          item.Title == "SIN_RIESGO" && item.Asintomatico == asintomatico
      ),
    });
  }

  descargarCertificado() {
    event.preventDefault();
    
    let data = {
      Site: window.location.origin + "/salud/transacciones/",
      TemplateUrl:
        window.location.origin +
        "/salud/transacciones/PlantillasDocWord/TemplateCertificadoAislamiento.docx",
      OutputFormat: ".pdf",
      DocumentName: "Certificado de Aislamiento",
      TemplateBookmarks: [
        { Key: "NOMBRE", Value: this.state.nombre },
        {
          Key: "TIPO_DOCUMENTO",
          Value: this.state.documentSelected.CSDocumentoIdentidadText,
        },
        { Key: "NUMERO_DOCUMENTO", Value: this.state.numeroDocumento },
        {
          Key: "FECHA_EXPEDICION",
          Value: this.state.fechaGeneracionCertificado
            ? this.state.fechaGeneracionCertificado[0].Valor
            : moment().format("DD/MM/YYYY h:mm a"),
        },
      ],
    };
    isCallService({
      // loadingElement: '',
      service: "CreateDocument",
      params: data,
      changeState: "file",
      executeCallback: (result) => {

        this.updateDescargarCertificadoColumn();

        const isIE =
          window.navigator.userAgent.includes("Trident/7.0") ||
          window.navigator.userAgent.includes("Edge");
        if (!isIE) {
          const file = document.createElement("a");
          file.href = "data:application/pdf;base64," + this.state.file.Base64;
          file.download = this.state.file.DocumentName;
          document.body.appendChild(file);
          file.click();
          document.body.removeChild(file);
        } else {
          const binary = atob(this.state.file.Base64.replace(/\s/g, ""));
          const buffer = new ArrayBuffer(binary.length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < binary.length; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const blob = new Blob([view], { type: "application/pdf;base64" });
          navigator.msSaveBlob(blob, this.state.file.Base64);
        }
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  handleGenericHtml(data) {
    return { __html: data };
  }

  handleGenericTitleHtml(data) {
    return { __html: data };
  }

  getFechaDescargaCertificado(lista) {
    let data = {
      Accion: "GET",
      Lista: "TemasCovid19-Riesgos",
      UrlSitio: window.location.origin + "/salud/transacciones/",
      Vista: [
        "DescargoCertificado",
        "ID",
        "FechaGeneracionCertificado",
        "Creado",
      ],
      Campos: {
        Query: [
          {
            NombreInternoCampo: "NumeroDocumento",
            Valor: this.state.numeroDocumento,
            Tipo: "Text",
          },
        ],
      },
    };
    isCallService({
      // loadingElement: '',
      service: "UtilidadSharepointGet",
      params: data,
      changeState: "usuarioExiste",
      executeCallback: (result) => {
        let fechaGeneracionCertificado = result.Resultado.map((item) => {
          return item.Valores.filter(
            (item) =>
              item.NombreInternoCampo === "FechaGeneracionCertificado" &&
              item.Valor !== ""
          );
        });
        let ordenFechas = fechaGeneracionCertificado.filter(
          (item) => item.length > 0
        );
        this.setState({
          fechaGeneracionCertificado:
            ordenFechas.length > 0 ? ordenFechas[ordenFechas.length - 1] : null,
        });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
  }

  handleSubmit(lista, result, formSelecionado = null) {
    let ciudad = result
      ? result.Ciudad == "" || result.Ciudad == " " || result.Ciudad == null
        ? this.state.ciudad
        : result.Ciudad
      : null;

    let plan = "";
    this.state.codigoPlan.CodigoPlan.length > 0
      ? this.state.codigoPlan.CodigoPlan[0] !== null
        ? this.state.codigoPlan.CodigoPlan.map((item) => {
            plan = plan + item + ",";
          })
        : null
      : null;
    let data = {
      Accion: "ADD",
      Lista: lista,
      UrlSitio: window.location.origin + "/salud/transacciones",
      Campos: {
        Valores: [
          { NombreInternoCampo: "NombreCompleto", Valor: this.state.nombre },
          {
            NombreInternoCampo: "TipoDocumento",
            Valor: this.state.documentSelected.CSSiglaText,
          },
          {
            NombreInternoCampo: "NumeroDocumento",
            Valor: this.state.numeroDocumento,
          },
          { NombreInternoCampo: "Telefono", Valor: this.state.celular },
          { NombreInternoCampo: "Email", Valor: this.state.email },
          { NombreInternoCampo: "Direccion", Valor: this.state.direccion },
          { NombreInternoCampo: "Ciudad", Valor: this.state.ciudad },
          { NombreInternoCampo: "Barrio", Valor: this.state.barrio },
          { NombreInternoCampo: "Localidad", Valor: this.state.localidad },
          { NombreInternoCampo: "CodigoPlan", Valor: plan },
          {
            NombreInternoCampo: "NombreCiudadRegistrada",
            Valor: this.state.codigoPlan.Ciudad,
          },
          {
            NombreInternoCampo: "CodigoCiudadRegistrada",
            Valor: this.state.codigoPlan.CodigoCiudad,
          },
        ],
      },
    };
    const formSelecionadoOption =
      this.state.formSeleccionado || formSelecionado;
    switch (formSelecionadoOption) {
      case 0:
        let riesgo = "";
        this.state.riesgos.Riesgos.map(
          (item) => (riesgo = riesgo + item + ", ")
        );
        let grupoFamiliar = this.handleGrupoFamiliarToString();
        data.Campos.Valores.push({
          NombreInternoCampo: "Departamento",
          Valor: this.state.departamento,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Riesgos",
          Valor: riesgo,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "FechaSintomas",
          Valor: this.state.fechaSintomas,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Pregunta1",
          Valor: this.state.form1Pregunta1,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Pregunta2",
          Valor: this.state.form1Pregunta2,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Pregunta3",
          Valor: this.state.form1Pregunta3,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "IPS",
          Valor:
            this.state.ips === "Seleccione una opción" ? null : this.state.ips,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "TipoDocumentoMedico",
          Valor:
            this.state.medicoDocumentSelected.CSSiglaText ===
            "elija un documento"
              ? null
              : this.state.medicoDocumentSelected.CSSiglaText,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "NumeroDocumentoMedico",
          Valor: this.state.numeroDocumentoMedico,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Embarazo",
          Valor: this.state.embarazo,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "SemanasGestacion",
          Valor: this.state.semanasGestacion,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "FechaRelacionContacto",
          Valor: this.state.fechaRelacionContacto,
        });

        (this.state.form1Pregunta1 ||
          this.state.form1Pregunta2 ||
          this.state.form1Pregunta3) &&
          grupoFamiliar.length > 0 &&
          data.Campos.Valores.push({
            NombreInternoCampo: "GrupoFamiliar",
            Valor: grupoFamiliar,
          });
        break;
      case 1:
        data.Campos.Valores.splice(5, 4);
        data.Campos.Valores.push({
          NombreInternoCampo: "MotivoSolicitud",
          Valor: this.state.motivo,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "NombreCiudadRegistrada",
          Valor: ciudad,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Departamento",
          Valor: this.state.departamento,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Ciudad",
          Valor: this.state.ciudad,
        });
        break;
      case 2:
        data.Campos.Valores.push({
          NombreInternoCampo: "Observaciones",
          Valor: this.state.observacion,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Departamento",
          Valor: this.state.departamento,
        });
        break;
      case 4:
        data.Campos.Valores.splice(6, 3);
        data.Campos.Valores.push({
          NombreInternoCampo: "CiudadOrigen",
          Valor: this.state.ciudad,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "CiudadDestino",
          Valor: this.state.ciudadDestino,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "FechaViaje",
          Valor: this.state.fechaViaje,
        });
        break;
      case 5:
        data.Campos.Valores.push({
          NombreInternoCampo: "ImposibilidadMedica",
          Valor: this.state.formVacunaPregunta1,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "PoblacionPriorizada",
          Valor: this.state.formVacunaPregunta2,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "TelefonoFijo",
          Valor: this.state.telefonoFijo,
        });
        data.Campos.Valores.push({
          NombreInternoCampo: "Departamento",
          Valor: this.state.departamento,
        });
        break;
      default:
        break;
    }
    isCallService({
      // loadingElement: '',
      service: "UtilidadSharepoint",
      params: data,
      changeState: "idUsuario",
      executeCallback: (result) => {
        if (this.state.formSeleccionado === 0) {
          this.setState({ showModalForm1: true });
        } else {
          this.setState({ showModal: true });
        }
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
    this.setState({ disable: true });
  }

  handleGrupoFamiliarToString() {
    let grupoFamiliar = this.state.codigoPlan.GrupoFamiliar.filter(
      (item) => item.isChecked === true
    );
    let grupoFamiliarString = "";
    grupoFamiliar.map((item, index) => {
      grupoFamiliarString = `${grupoFamiliarString} \-\[${index + 1}]${
        item.Nombre
      },${item.TipoDocumento},${item.NumeroDocumento}${item.Parentesco}\-\ `;
    });
    return grupoFamiliarString;
  }

  updateDocument(document) {
    this.setState({ documentSelected: document, numeroDocumento: "" });
  }

  updateObservacion(observacion) {
    this.setState({ observacion });
  }

  updateSintomas(pregunta, sintoma) {
    switch (sintoma) {
      case "sintoma1":
        this.setState({ form1Pregunta1: pregunta }, () => {
          this.handleModalMessage();
        });
        break;
      case "sintoma2":
        this.setState({ form1Pregunta2: pregunta }, () => {
          this.handleModalMessage();
        });
        break;
      case "sintoma3":
        this.setState({ form1Pregunta3: pregunta }, () => {
          this.handleModalMessage();
        });
        break;
      case "embarazo":
        this.setState({ embarazo: pregunta }, () => {
          this.handleModalMessage();
        });
        break;
      case "formVacunaPregunta1":
        this.setState({ formVacunaPregunta1: pregunta });
        break;
      case "formVacunaPregunta2":
        this.setState({ formVacunaPregunta2: pregunta });
      default:
        //console.log("non of those above");
        break;
    }
  }

  handleIps(item) {
    this.setState({ ips: item });
  }

  handleMedicodocument(document) {
    this.setState({ medicoDocumentSelected: document });
  }

  handleMotivo(motivo) {
    this.setState({ motivo });
  }

  handleCiudadDestino(ciudad) {
    this.setState({ ciudadDestino: ciudad });
  }

  handleDireccion(direccion, barrio, observacion) {
    this.setState({ direccion });
    barrio ? this.setState({ barrio }) : null;
    observacion ? this.setState({ observacionDireccion: observacion }) : null;
  }

  handleConvivenciaBeneficiario(item, index) {
    let grupoFamiliar = this.state.codigoPlan;
    grupoFamiliar.GrupoFamiliar[index].isChecked = !item.isChecked;
    this.setState({ codigoPlan: { ...grupoFamiliar } });
  }

  handleTerminosCondiciones(aceptaTerminos) {
    this.setState({
      aceptaTerminosCondiciones: aceptaTerminos,
      modalTerminosyCondiciones: aceptaTerminos ? true : false,
    });
  }

  scrollTo() {
    let element = document.getElementById("nav-tabContent");
    element.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    let nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      direccion,
      barrio,
      ciudad,
      localidad,
      motivo,
      observacion;
    [
      nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      direccion,
      barrio,
      ciudad,
      localidad,
      motivo,
      observacion,
    ] = [
      this.state.nombre,
      this.state.documentSelected.CSDocumentoIdentidadText,
      this.state.numeroDocumento,
      this.state.email,
      this.state.emailIsValid,
      this.state.celular,
      this.state.direccion,
      this.state.barrio,
      this.state.ciudad,
      this.state.localidad,
      this.state.motivo,
      this.state.observacion,
    ];

    return (
      <section id="covidForm" className="mainLayout_etapa_priorizacion">
        <div className="loadingWraper">
          <div className="compensarLoading">
            <span>cargando... </span>
          </div>
        </div>
        <h1>{i18next.t("bienvenida.titulo")}</h1>
        <p>{i18next.t("bienvenida.subtitulo")}</p>

        <div className="mainBox--mobil">
          <div
            onClick={() =>
              this.setState({ formSeleccionado: 5 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-vacuna-tab"
            data-toggle="tab"
            href="#nav-vacuna"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Vacuna.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card6"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card6")}</h3>
            </div>
          </div>

          <div
            onClick={() =>
              this.setState({ formSeleccionado: 0 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-sintomas"
            data-toggle="tab"
            href="#nav-sintoma"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Reporte%20%20de%20%20sintomas.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card1"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card1")}</h3>
            </div>
          </div>

          <div
            onClick={() =>
              this.setState({ formSeleccionado: 1 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-home-tab"
            data-toggle="tab"
            href="#nav-certificado"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Certificado.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card2"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card2")}</h3>
            </div>
          </div>

          <div
            onClick={() =>
              this.setState({ formSeleccionado: 2 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-inquietudes"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Muestras.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card3"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card3")}</h3>
            </div>
          </div>

          <div
            onClick={() =>
              this.setState({ formSeleccionado: 3 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-contactos-tab"
            data-toggle="tab"
            href="#nav-contactos"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Contacto.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card4"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card4")}</h3>
            </div>
          </div>
          {/*
          <div
            onClick={() =>
              this.setState({ formSeleccionado: 4 }, () => this.scrollTo())
            }
            className="mainBox--mobil-child flex"
            id="nav-viajes-tab"
            data-toggle="tab"
            href="#nav-viajes"
            role="tab"
          >
            <img
              width="100"
              height="100"
              src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Viaje.png`}
              alt={`imagen de referencia de dibujo animado de ${i18next.t(
                "cards.card5"
              )}`}
            ></img>
            <div className="mainBox-child">
              <h3 className="mainBox-title">{i18next.t("cards.card5")}</h3>
            </div>
          </div>
          */}
        </div>

        <div
          className="mainBox"
          // id="simplebar-scrollbar-covid"
        >
          <div className="mainBox-scroll">
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Vacuna.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card"
                )}`}
              ></img>
              <h3 className="mainBox-title">{i18next.t("cards.card6")}</h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 5 })}
                className="btn btn-default mainBox-button"
                id="nav-vacuna-tab"
                data-toggle="tab"
                href="#nav-vacuna"
                role="tab"
                aria-controls="nav-vacuna"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Reporte%20%20de%20%20sintomas.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card1"
                )}`}
              ></img>
              <h3 className="mainBox-title">{i18next.t("cards.card1")}</h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 0 })}
                className="btn btn-default mainBox-button"
                id="nav-sintomas"
                data-toggle="tab"
                href="#nav-sintoma"
                role="tab"
                aria-controls="nav-home"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Certificado.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card2"
                )}`}
              ></img>
              <h3 className="mainBox-title">
                {i18next.t("cards.card2")}&nbsp;&nbsp;
              </h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 1 })}
                className="btn btn-default mainBox-button"
                id="nav-home-tab"
                data-toggle="tab"
                href="#nav-certificado"
                role="tab"
                aria-controls="nav-home"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Muestras.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card3"
                )}`}
              ></img>
              <h3 className="mainBox-title">{i18next.t("cards.card3")}</h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 2 })}
                className="btn btn-default mainBox-button"
                id="nav-profile-tab"
                data-toggle="tab"
                href="#nav-inquietudes"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Contacto.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card4"
                )}`}
              ></img>
              <h3 className="mainBox-title">{i18next.t("cards.card4")}</h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 3 })}
                className="btn btn-default mainBox-button"
                id="nav-contactos-tab"
                data-toggle="tab"
                href="#nav-contactos"
                role="tab"
                aria-controls="nav-contactos"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            {/*
            <div className="text-center mainBox-child">
              <img
                width="100"
                className="content-img"
                src={`${window.location.origin}/salud/transacciones/SiteAssets/IconosCovid/Viaje.png`}
                alt={`imagen de referencia de dibujo animado de ${i18next.t(
                  "cards.card4"
                )}`}
              ></img>
              <h3 className="mainBox-title">{i18next.t("cards.card5")}</h3>
              <a
                onClick={() => this.setState({ formSeleccionado: 4 })}
                className="btn btn-default mainBox-button"
                id="nav-viajes-tab"
                data-toggle="tab"
                href="#nav-viajes"
                role="tab"
                aria-controls="nav-contactos"
                aria-selected="false"
              >
                {i18next.t("cards.button")}
              </a>
            </div>
            */}
          </div>
        </div>

        <div className="tab-content" id="nav-tabContent">
          <Sintomas
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            plan={this.state.codigoPlan ? this.state.codigoPlan.CodigoPlan : ""}
            email={this.state.email}
            emailIsValid={this.state.emailIsValid}
            celular={this.state.celular}
            direccion={this.state.direccion}
            barrio={this.state.barrio}
            ciudad={this.state.ciudad}
            ciudadesList={this.state.ciudadesListFromDepartamento}
            departamento={this.state.departamento}
            departamentosList={this.state.departamentosList}
            localidad={this.state.localidad}
            fecha={this.state.fechaSintomas}
            fechaRelacionContacto={this.state.fechaRelacionContacto}
            documentos={this.state.documentos}
            embarazo={this.state.embarazo}
            semanasGestacion={this.state.semanasGestacion}
            form1Pregunta1={this.state.form1Pregunta1}
            form1Pregunta2={this.state.form1Pregunta2}
            form1Pregunta3={this.state.form1Pregunta3}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            collapse={this.state.collapse}
            ipsList={this.state.ipsList}
            ips={this.state.ips}
            medicoDocumentSelected={this.state.medicoDocumentSelected}
            grupoFamiliar={
              this.state.codigoPlan != undefined
                ? this.state.codigoPlan.GrupoFamiliar
                : []
            }
            handleDireccion={this.handleDireccion}
            getDepartamentos={this.getDepartamentos}
            updateocumentSelected={this.updateDocument}
            handleInput={this.handleInput}
            consultarRieso={this.consultarRieso}
            updateSintomas={this.updateSintomas}
            numeroDocumentoMedico={this.state.numeroDocumentoMedico}
            showForm={this.state.showForm}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
            // disabled={nombre == "" || nombre == null || id == "elija un documento" || id == null || idNum == "" || idNum == null || email == "" || email == null || celular == "" || celular == null || direccion == "" || direccion == null || barrio == "" || barrio == null || ciudad == "" || ciudad == null ? true : false}
            handleSubmit={this.handleSubmit}
            handleCollapse={() =>
              this.setState({ collapse: !this.state.collapse })
            }
            handleIps={this.handleIps}
            handleMedicodocument={this.handleMedicodocument}
            handleConvivenciaBeneficiario={this.handleConvivenciaBeneficiario}
          />
          <CertificadoAislamiento
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            email={this.state.email}
            emailIsValid={this.state.emailIsValid}
            ciudad={this.state.ciudad}
            ciudadesList={this.state.ciudadesListFromDepartamento}
            departamento={this.state.departamento}
            departamentosList={this.state.departamentosList}
            celular={this.state.celular}
            documentos={this.state.documentos}
            opcionesMotivo={this.state.opcionesMotivo}
            motivo={this.state.motivo}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            getDepartamentos={this.getDepartamentos}
            handleGenericHtml={this.handleGenericHtml}
            updateocumentSelected={this.updateDocument}
            showFormAislamiento={this.showFormAislamiento}
            handleInput={this.handleInput}
            handleMotivo={this.handleMotivo}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
            /*handlePlan={this.handlePlan}*/
            descargarCertificado={this.descargarCertificado}
            consultarRiesgoAislamiento={this.consultarRiesgoAislamiento}
          />
          <Viajes
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            email={this.state.email}
            emailIsValid={this.state.emailIsValid}
            celular={this.state.celular}
            documentos={this.state.documentos}
            direccion={this.state.direccion}
            ciudad={this.state.ciudad}
            ciudadDestino={this.state.ciudadDestino}
            fecha={this.state.fechaViaje}
            pregunta1={this.state.formVacunaPregunta1}
            pregunta2={this.state.formVacunaPregunta2}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            handleDireccion={this.handleDireccion}
            handleGenericHtml={this.handleGenericHtml}
            updateocumentSelected={this.updateDocument}
            handleInput={this.handleInput}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
            handlePlan={this.handlePlan}
            ciudadesList={this.state.ciudadesList}
            handleCiudadDestino={this.handleCiudadDestino}
          />
          <Vacuna
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            fechaNacimiento={this.state.fechaNacimiento}
            direccion={this.state.direccion}
            barrio={this.state.barrio}
            localidad={this.state.localidad}
            ciudad={this.state.ciudad}
            ciudadesList={this.state.ciudadesListFromDepartamento}
            departamento={this.state.departamento}
            departamentosList={this.state.departamentosList}
            email={this.state.email}
            emailIsValid={this.state.emailIsValid}
            celular={this.state.celular}
            telefonoFijo={this.state.telefonoFijo}
            documentos={this.state.documentos}
            opcionesMotivo={this.state.opcionesMotivo}
            pregunta1={this.state.formVacunaPregunta1}
            pregunta2={this.state.formVacunaPregunta2}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            handleDireccion={this.handleDireccion}
            getDepartamentos={this.getDepartamentos}
            handleGenericHtml={this.handleGenericHtml}
            updateocumentSelected={this.updateDocument}
            handleInput={this.handleInput}
            handleMotivo={this.handleMotivo}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
            handlePlan={this.handlePlan}
            updateSintomas={this.updateSintomas}
            handleBlur={this.consultarRieso}
          />
          <ResultadosPruebas
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            email={this.state.email}
            emailIsValid={this.state.emailIsValid}
            celular={this.state.celular}
            telefonoFijo={this.state.telefonoFijo}
            documentos={this.state.documentos}
            direccion={this.state.direccion}
            barrio={this.state.barrio}
            ciudad={this.state.ciudad}
            ciudadesList={this.state.ciudadesListFromDepartamento}
            departamento={this.state.departamento}
            departamentosList={this.state.departamentosList}
            localidad={this.state.localidad}
            observacionesList={this.state.observaciones}
            observacion={this.state.observacion}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            handleDireccion={this.handleDireccion}
            getDepartamentos={this.getDepartamentos}
            handleGenericHtml={this.handleGenericHtml}
            updateocumentSelected={this.updateDocument}
            handleInput={this.handleInput}
            handleMotivo={this.handleMotivo}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
            handlePlan={this.handlePlan}
            handleObservaciones={this.updateObservacion}
          />
          <Contactos
            nombre={this.state.nombre}
            documentSelected={this.state.documentSelected}
            numeroDocumento={this.state.numeroDocumento}
            documentos={this.state.documentos}
            ciudad={this.state.ciudad}
            aceptaTerminosCondiciones={this.state.aceptaTerminosCondiciones}
            aceptaRecibirInformacion={this.state.aceptaRecibirInformacion}
            handleInput={this.handleInput}
            updateocumentSelected={this.updateDocument}
            handleTerminosCondiciones={this.handleTerminosCondiciones}
            handleAceptaRecibirInformacion={() =>
              this.setState({
                aceptaRecibirInformacion: !this.state.aceptaRecibirInformacion,
              })
            }
          />
        </div>

        {this.state.modalTerminosyCondiciones ? (
          <ModalGeneral
            showModal={this.state.modalTerminosyCondiciones}
            closeModal={() =>
              this.setState({ modalTerminosyCondiciones: false })
            }
            MessageTitle={this.state.politicaTratamientoDatos[0].Title}
            msg={
              <div
                dangerouslySetInnerHTML={this.handleGenericHtml(
                  this.state.politicaTratamientoDatos[0].TerminosCondiciones
                )}
              />
            }
            AltButtonAction={() =>
              this.setState({ modalTerminosyCondiciones: true })
            }
            AltButtonText={i18next.t("modales.buttonAceptar")}
          />
        ) : null}

        {this.state.showModalForm1 ? (
          <Mensajes
            showModal={this.state.showModalForm1}
            closeModal={() =>
              this.setState(
                { showModalForm1: false, showForm: false, collapse: false },
                () => this.limpiarForm()
              )
            }
            MessageTitle={this.state.mensajeRiesgoTitle}
            Icono={"fa fa-info-circle"}
            colorIco={"blue"}
            msg={<div dangerouslySetInnerHTML={this.handleFirstFormModal()} />}
            MainButtonAction={() => this.descargarCertificado()}
            MainButtonText={
              this.state.showPDFButton ? i18next.t("modales.descargar") : null
            }
            AltButtonAction={() =>
              this.setState(
                { showModalForm1: false, showForm: false, collapse: false },
                () => this.limpiarForm()
              )
            }
            AltButtonText={i18next.t("modales.buttonAceptar")}
          />
        ) : null}
        <Mensajes
          showModal={this.state.showModal}
          closeModal={() =>
            this.setState({ showModal: false }, () => this.limpiarForm())
          }
          MessageTitle={i18next.t("modales.titulo")}
          Icono={"fa fa-info-circle"}
          colorIco={"blue"}
          msg={i18next.t("modales.mensaje")}
          AltButtonAction={() =>
            this.setState({ showModal: false }, () => this.limpiarForm())
          }
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />
        <Mensajes
          showModal={this.state.error}
          closeModal={() => this.setState({ error: false })}
          MessageTitle={i18next.t("modales.tituloError")}
          Icono={"fa fa-times-circle-o"}
          colorIco={"red"}
          msg={
            this.state.sinUsuario
              ? i18next.t("modales.sinUsuario")
              : i18next.t("modales.error")
          }
          AltButtonAction={() => this.setState({ error: false })}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />
      </section>
    );
  }
}

ReactDom.render(<Index />, document.getElementById("covid-19"));
